/**
 * Parallel coordinate transformations for parallel coordinate.
 */
export var Parallel = function Parallel() {
  return [['parallel', 0, 1, 0, 1]];
};
Parallel.props = {};